
export default {
  name: "FilterSelect",
  props: {
    data: {
      type: Array,
      default: () => []
    },
    label: {
      type: String,
      default: 'filter'
    },
    value: {
      default: null,
    }
  },
  data() {
    return {
      selection: null,
      selected: null,
    }
  },
  beforeMount() {
    this.selected = this.value;
  },
  methods: {
    clear() {
      this.selected = null;
    }
  },
  watch: {
    selected() {
      this.$emit('input', this.selected);
    }
  }
}

